import React from 'react';
import PropTypes from 'prop-types';

import { Field } from 'formik';

const Checkbox = props => {
  const { name, value, view, disabled } = props;
  let customClassName = '';

  switch (view) {
    case 'block':
      customClassName = 'flex-column-reverse block ml-md-2 mr-md-2 p-0';
      break;
    case 'double':
      customClassName = 'double flex-1 col-md-6 col-sm-12 ml-md-2 mr-md-2 p-0';
      break;
    default:
      customClassName = 'mr-2';
      break;
  }

  const handleChange = (field, form) => {
    if (field.value.includes(value)) {
      const nextValue = field.value.filter(filedValue => filedValue !== value);
      form.setFieldValue(name, nextValue);
    } else {
      const nextValue = field.value.concat(value);
      form.setFieldValue(name, nextValue);
    }
  };

  return (
    <Field name={name}>
      {({ field, form }) => (
        <div
          className={`checkbox-field form-control d-flex align-items-center mb-2 ${customClassName}${
            field.value.includes(value) ? ' active' : ''
          }`}
          onClick={() => !disabled && handleChange(field, form)}
        >
          <div className="checkbox-wrapper">
            <input
              type="checkbox"
              className="mr-1"
              name={name}
              value={value}
              checked={field.value.includes(value)}
              onChange={() => handleChange(field, form)}
              disabled={disabled}
            />
            <span className="checkmark" />
          </div>
          <div className="flex-1 caption">{value}</div>
        </div>
      )}
    </Field>
  );
};

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  view: PropTypes.string,
  disabled: PropTypes.bool,
};

Checkbox.defaultProps = {
  view: '',
  disabled: false,
};

export default Checkbox;
